import { Action, ActionReducer, createFeature, createReducer, on } from '@ngrx/store';

import * as NoteActions from './note.actions';
import { initialState, NoteState } from './note.state';

export const noteReducer: ActionReducer<NoteState, Action<string>> = createReducer(
  initialState,

  on(
    NoteActions.loadNotes,
    (state): NoteState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    NoteActions.loadNotesSuccess,
    (state, { notes, totalCount }): NoteState => ({
      ...state,
      notes,
      totalCount,
      loading: false,
    })
  ),

  on(
    NoteActions.loadNotesFailure,
    (state, { error }): NoteState => ({
      ...state,
      loading: false,
      error,
    })
  ),

  on(
    NoteActions.loadNote,
    (state): NoteState => ({
      ...state,
      selectedNote: null,
      loading: true,
      error: null,
    })
  ),

  on(
    NoteActions.loadNoteSuccess,
    (state, { note }): NoteState => ({
      ...state,
      selectedNote: note,
      loading: false,
    })
  ),

  on(
    NoteActions.loadNoteFailure,
    (state, { error }): NoteState => ({
      ...state,
      loading: false,
      error,
    })
  ),

  on(
    NoteActions.enrichNotesWithUserNames,
    (state, { notes }): NoteState => ({
      ...state,
      notes,
    })
  ),

  on(
    NoteActions.enrichSelectedNoteWithUserNames,
    (state, { note }): NoteState => ({
      ...state,
      selectedNote: note,
    })
  ),

  on(
    NoteActions.enrichNoteWithProductName,
    (state, { productName }): NoteState => ({
      ...state,
      selectedNote: state.selectedNote ? { ...state.selectedNote, productName } : null,
    })
  ),

  on(
    NoteActions.deleteNote,
    (state): NoteState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    NoteActions.deleteNoteSuccess,
    (state, { id }): NoteState => ({
      ...state,
      notes: state.notes.filter(note => note.id !== id),
      selectedNote: state.selectedNote?.id === id ? null : state.selectedNote,
      totalCount: state.totalCount - 1,
      loading: false,
    })
  ),

  on(
    NoteActions.deleteNoteFailure,
    (state, { error }): NoteState => ({
      ...state,
      loading: false,
      error,
    })
  )
);

export const noteFeature: ReturnType<typeof createFeature<string, NoteState>> = createFeature({
  name: 'notesAdmin',
  reducer: noteReducer,
});
